import {
  link,
  typedObject,
} from '@dspace/core/cache/builders/build-decorators';
import { PaginatedList } from '@dspace/core/data/paginated-list.model';
import { RemoteData } from '@dspace/core/data/remote-data';
import { HALLink } from '@dspace/core/shared/hal-link.model';
import {
  autoserialize,
  deserialize,
  inheritSerialization,
} from 'cerialize';
import { Observable } from 'rxjs';

import { VOCABULARY_ENTRY_DETAIL } from './vocabularies.resource-type';
import { VocabularyEntry } from './vocabulary-entry.model';

/**
 * Model class for a VocabularyEntryDetail
 */
@typedObject
@inheritSerialization(VocabularyEntry)
export class VocabularyEntryDetail extends VocabularyEntry {
  static type = VOCABULARY_ENTRY_DETAIL;

  /**
   * The unique id of the entry
   */
  @autoserialize
  id: string;

  /**
   * In an hierarchical vocabulary representing if entry is selectable as value
   */
  @autoserialize
  selectable: boolean;

  /**
   * The {@link HALLink}s for this ExternalSourceEntry
   */
  @deserialize
  _links: {
    self: HALLink;
    vocabulary: HALLink;
    parent: HALLink;
    children: HALLink;
  };

  /**
   * The submitter for this SubmissionObject
   * Will be undefined unless the submitter {@link HALLink} has been resolved.
   */
  @link(VOCABULARY_ENTRY_DETAIL)
  parent?: Observable<RemoteData<VocabularyEntryDetail>>;

  /**
   * The submitter for this SubmissionObject
   * Will be undefined unless the submitter {@link HALLink} has been resolved.
   */
  @link(VOCABULARY_ENTRY_DETAIL, true)
  children?: Observable<RemoteData<PaginatedList<VocabularyEntryDetail>>>;

}
